import { ArrayUtils } from '@everyboard/lib';
import { PlayerNumberMap } from '../../jscaip/PlayerMap';
import { GameState } from '../../jscaip/state/GameState';
import { ApagosSquare } from './ApagosSquare';
export class ApagosState extends GameState {
    board;
    remaining;
    /**
     * The representation works as follows: board is made of three rows:
     * - the first row contains the number of pieces from player 0, in each square
     * - the second row contains the number of pieces from player 1, in each square
     * - the third row contains the size of each square
     */
    static fromRepresentation(turn, board, nZero, nOne) {
        const squares = [];
        for (let x = 0; x < board[0].length; x++) {
            const localZeroCount = board[0][x];
            const localOneCount = board[1][x];
            const nbTotal = board[2][x];
            const square = ApagosSquare.from(localZeroCount, localOneCount, nbTotal).get();
            squares.push(square);
        }
        const remaining = PlayerNumberMap.of(nZero, nOne);
        return new ApagosState(turn, squares, remaining);
    }
    constructor(turn, board, remaining) {
        super(turn);
        this.board = board;
        this.remaining = remaining;
        this.remaining.makeImmutable();
    }
    getPieceAt(x) {
        return this.board[x];
    }
    updateAt(x, newSquare) {
        const newBoard = [];
        for (let pos = 0; pos < this.board.length; pos++) {
            if (pos === x) {
                newBoard.push(newSquare);
            }
            else {
                newBoard.push(this.board[pos]);
            }
        }
        const remaining = this.getRemainingCopy();
        return new ApagosState(this.turn, newBoard, remaining);
    }
    getRemainingCopy() {
        return this.remaining.getCopy();
    }
    getRemaining(piece) {
        return this.remaining.get(piece);
    }
    getMaxPiecesPerPlayer() {
        let numberOfPieces = 0; // number of piece should be just enough to have the majority everywhere
        for (const square of this.board) {
            numberOfPieces += Math.floor(square.getCapacity() / 2) + 1; // works both for even or odd sizes
        }
        return numberOfPieces;
    }
    equals(other) {
        return this.turn === other.turn &&
            ArrayUtils.equals(other.board, this.board) &&
            this.remaining.equals(other.remaining);
    }
    toString() {
        return `[${this.board.map((square) => square.toString()).join(', ')}]`;
    }
}
